import { Controller } from 'stimulus';

export default class PrintController extends Controller {
  connect() {
    window.print();
  }
}
